module.exports = __webpack_public_path__ + "img/logo.ec9da339.jpeg";